import { App } from "../work-modules/039/app";

document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById("webgl-canvas") as HTMLCanvasElement;
  const app = new App(canvas);
  app.init();
});
